import { render, staticRenderFns } from "./ot-subscriber.vue?vue&type=template&id=7840d340"
import script from "./ot-subscriber.vue?vue&type=script&lang=js"
export * from "./ot-subscriber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports